
















































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import states from '@assets/states.json'
import dmas from '@assets/dma.json'
import cities from '@assets/cities.json'
import TagBar from '@ui/TagBar'
import sort from  '@utils/sort.coffee'

settings =
  name: 'Selector'

  vue:
    props: ['mode', 'selectedKeys', 'selectOptions', 'actions', 'theme', 'options']
    components: { TagBar }

    data: ->
      selectorSearch: ''
      uiOptions: []

    mounted: ->
      @uiOptions = [...@selectOptions]

    computed:
      modeType: -> @mode || 'multi'
      maxHeight: -> @theme?.maxHeight || '800px'
      uiVisibleOptions: -> @uiOptions.slice(0, 100)

      showSearchBox: -> !@options?.searchBox
      showTagBar: -> if @options?.showTagBar? then @options.showTagBar else true
      searchPlaceholder: -> @options?.searchBoxPlaceholder || 'Search by name'
      selectOptionsTitle: ->
        return false if @options?.selectOptionsTitle? && !@options?.selectOptionsTitle
        @options?.selectOptionsTitle || 'Select'

      selectedOptions: -> @selectOptions.filter((option) => @selectedKeys.includes(option.key))

      hasTagBarSlot: -> @$slots['tag-bar']?
      hasExtraFieldSlot: -> @$slots['extra-field']?
      tagBarOptions: -> @options?.tagBarOptions || @defaultTagBarOptions

      selectedIconClass: ->
        if @modeType is 'multi'
          'fas fa-check-square'
        else
          'fas fa-check-square'

      unselectedIconClass: ->
        if @modeType is 'multi'
          'far fa-square'
        else
          'far fa-circle'

      defaultTagBarOptions: ->
        {
          bar: {
            theme: 'selector',
            max: 4
          },
          tag: {
            theme: 'selector',
            maxLength: 8
          },
          initializeExpanded: true
        }

    methods:
      hiToggleSelect: (option) ->
        if @selectedKeys.includes option.key
          @hiUnselect option
        else
          @hiSelect option

      hiSelect: (option) -> @actions?.select option
      hiUnselect: (option) -> @actions?.unselect option

      hiSelectAll: -> @actions?.selectAll?(@selectOptions)
      hiUnselectAll: -> @actions?.unselectAll?()

      debounce: (cb, time = 250) ->
        clearTimeout(@searchTime)
        @searchTime = setTimeout(cb, time)

      hiSearch: (value) ->
        if @actions.search?
          @debounce(() => @actions.search(value))
          return

        if not value.length
          @uiOptions = @selectOptions
          return

        @debounce(() =>
          selectorOptions = @selectOptions.filter((option) ->
            short = option.value.split(' ').map((word) -> word.charAt(0)).join('')
            text = "#{Object.values(option).join(' ')} #{short}".toLowerCase()
            target = "#{value}".toLowerCase()
            keep = text.includes(target)
            keep ||= text.includes(target[0..-2])
            keep
          )

          sortField = "sortBy"
          selectorOptions = selectorOptions.sort(sort.matchSort(value, sortField))
          selectorOptions = selectorOptions.sort(@options.searchSort(value, sortField)) if @options?.searchSort?
          @uiOptions = selectorOptions
          @actions?.searchTextChange?()
        )

      clearSearch: ->
        @selectorSearch = ''
        @hiSearch ''

    watch:
      selectOptions: ->
        @uiOptions = [...@selectOptions]

export default VueOptions.vue settings
